import type { NavigateHandler } from "./types";

const DEFAULT_CHECKOUT_PATH = "/comprar?go_to_checkout=1";

const CHECKOUT_PATH_BY_THEME: Record<string, string> = {
	patagonia: "/complete",
};

/** The checkout start, which depends on the store's theme. */
export const checkout: NavigateHandler = {
	handler({ runtime }) {
		const { theme } = runtime.getState().store;
		// Own-key guard: a plain index would resolve inherited keys such as `"constructor"`.
		const themePath = Object.hasOwn(CHECKOUT_PATH_BY_THEME, theme)
			? CHECKOUT_PATH_BY_THEME[theme]
			: undefined;
		window.location.href = themePath ?? DEFAULT_CHECKOUT_PATH;
	},
};
